import { h } from 'preact';
import { Avatar } from '../Avatar';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Avatar',
  category: '📊 Data Display',
  description: 'Avatar com iniciais, imagem, 3 tamanhos e status (online, busy)',
  usedIn: ['AgentesPage', 'ChatHubPage', 'Profile'],
  example: () => (
    <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
      <Avatar name="Gustavo Lemos" size="sm" />
      <Avatar name="Elon Parker" size="md" status="online" />
      <Avatar name="Admin User" size="lg" status="busy" />
      <Avatar src="https://i.pravatar.cc/150?img=3" name="Foto" size="lg" status="online" />
    </div>
  ),
};
